export enum stackEnum {
    shopStack = 'shopStack',
    serviceStack = 'serviceStack',
    stocksStack = 'stocksStack',
    dashboardStack = 'dashboardStack',
    settingsStack = 'settingsStack',
}
